module.exports = __webpack_public_path__ + "img/switch-on.8e45183d.png";